<template>
  <footer class="footer has-background-white-ter">
    <div class="container">
        <div class="has-text-centered">
            <p>
                <a href="https://www.facebook.com/groups/171978979537213">
                    <i class="fab fa-facebook-square fa-2x"></i>
                </a>
                <a href="">
                    <i class="fab fa-twitter-square fa-2x"></i>
                </a>
                <a href="">
                    <i class="fab fa-instagram fa-2x"></i>
                </a>
                <a href="">
                    <i class="fab fa-snapchat fa-2x"></i>
                </a>
            </p>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MagicLayoutFooter'
}
</script>



// WEBPACK FOOTER //
// src/layouts/magic-layout/MagicLayoutFooter.vue